import { Component, Input, OnInit } from '@angular/core';
import { MappingTipiEntitaPratica } from "../../../common/configuration/mapping-tipi-entita-pratica";
import { FrontEndMapping } from '../../configuration/front-end-mapping';
import { ServicePathsSettings } from '../../configuration/service-paths-settings';
import { AttivitaCompletare } from '../../models/attivita-completare';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';

@Component({
  selector: '[attivita-completare-list]',
  templateUrl: 'attivita-completare-list.component.html',
  styleUrls: ['./attivita-completare-list.component.css']
})

export class AttivitaCompletareListComponent implements OnInit {

  @Input()
  attivitaList: AttivitaCompletare[];

  @Input()
  slice: number;
  ID_PRATICA_PARERISTICA = MappingTipiEntitaPratica.PRATICA_PARERISTICA;
  constructor(private viewManager: ViewManagerService, private operationsService: OperationsService, private frontEndMapping: FrontEndMapping) {}

  ngOnInit() {
    if (this.slice && this.slice > 0 && this.slice < this.attivitaList.length) {
      this.attivitaList =  this.attivitaList.slice(0, this.slice);
    }
  }

  public getLabelInsert(): string {
    return ServicePathsSettings.insLabel;
  }

  getPraticaPathFromType(idTipoPratica: string) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(idTipoPratica).subscribe(res => {
      tipoPratica = res;
    });
    return tipoPratica;
    // return FrontEndMapping.tipiPratica[idTipoPratica];
  }

  tipoFascicoloString(idTipoFascicolo: string) {
    // let tipoFascicolo = FrontEndMapping.tipiFascicolo[idTipoFascicolo];
    let tipoFascicolo = '';
    this.frontEndMapping.getListTipiFascicolo(idTipoFascicolo).subscribe(res => {
      tipoFascicolo = res;
    });
    return tipoFascicolo;
  }

  getSezioneDestinazione(chiave: string) {
    if (chiave == 'smistamento') {
      return 'assegnazione_per_smistamento';
    } else if (chiave == 'assegnazione') {
      return 'assegnazione_per_competenza';
    } else if (chiave == 'lavorazione') {
      return 'legali_fascicolo';
    } else if (chiave == 'inserimento') {
      return 'dati_generali_fascicolo';
    } else if (chiave == 'notifica_fondo_rischi') {
      return 'sezione_economica';
    }
    return null;
  }
}
